import http from '../_http_v2';

const dashboard = {
  //default
  month: (m) => { return http.get(`console/wsfinder/dashboard/month`, m); },
  week: (m) => { return http.get(`console/wsfinder/dashboard/week`, m); },
  agent: (m) => { return http.get(`console/wsfinder/dashboard/agent`, m); },

  status: (m) => { return http.get(`console/wsfinder/dashboard/status`, m); },

  //wfdetector
  monthForgery: (m) => { return http.get(`console/wsfinder/dashboard/month/forgery`, m); },
  weekForgery: (m) => { return http.get(`console/wsfinder/dashboard/week/forgery`, m); },
  agentForgery: (m) => { return http.get(`console/wsfinder/dashboard/agent/forgery`, m); },
}

export default dashboard

export { dashboard }